<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import { Helper } from "@/mixin/helper";

import { required } from "vuelidate/lib/validators";

import {
  DEVICE_MUTATION_DELETE,
  DEVICE_MUTATION_UPDATE,
  DEVICE_MUTATION_CREATE,
  GET_DEVICES,
  GET_DEVICE_HISTORIES,
  GET_DEVICE_LOGS,
  GET_DEVICE_TYPES
} from "@/services/api/master/tracking";
/**
 * Starter component
 */
export default {
  page: {
    title: "Data Tracking",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  apollo: {
    devices: {
      query: GET_DEVICES,
      variables() {
        return {
          filter: {
            vendorCode: this.filterApi.vendorCode,
            deviceCode: this.filterApi.deviceCode,
            status: this.filterApi.status,
            orderBy: this.filterApi.orderBy,
          },
        };
      },
      result({ data, loading }) {
        if (loading) return;
        this.totalRows = data.devices.devices.length;
        this.filteredItems = data.devices.devices;
      },
    },
    deviceTypes: {
      query: GET_DEVICE_TYPES,
      result({data, loading}){
        if (loading) return;
        this.deviceTypeOptions = data.deviceTypes.deviceType.map(device => ({
          value: device.deviceCode,
          label: device.deviceName
        }))
      }
    },
    deviceHistories: {
      query: GET_DEVICE_HISTORIES,
      skip() {
        return !this.form.imei;
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            imei: this.form.imei,
          },
        };
      },
      result({ data, loading }) {
        if (loading) return;
        data.deviceHistories.deviceHistories.forEach(row => {
          row.activeOnDateFormat = this.momentDateShortMonth(row.activeOn)
          row.activeOnTimeFormat = this.momentTime(row.activeOn)

          row.inactiveOnDateFormat = this.momentDateShortMonth(row.inactiveOn)
          row.inactiveOnTimeFormat = this.momentTime(row.inactiveOn)
        });

        this.historyRows = data.deviceHistories.deviceHistories.length;
        this.history = data.deviceHistories.deviceHistories;
      },
    },
    deviceLogs: {
      query: GET_DEVICE_LOGS,
      skip() {
        return !this.form.imei;
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            imei: this.form.imei,
          },
        };
      },
      result({ data, loading }) {
        if (loading) return;
        data.deviceLogs.deviceLogs.forEach(row => {
          row.messageOnDateFormat = this.momentDateShortMonth(row.messageOn)
          row.messageOnTimeFormat = this.momentTime(row.messageOn)
        });

        this.activityRows = data.deviceLogs.deviceLogs.length;
        this.activity = data.deviceLogs.deviceLogs;
      },
    },
  },
  mixins: [Helper],
  data() {
    return {
      phaseOneShow: false,
      filterApi: {
        vendorCode: null,
        deviceCode: null,
        status: null,
        orderBy: [JSON.stringify({ imei: "asc" })],
      },
      selected: {
        tracking: [],
      },
      selectedModel: {
        tracking: [],
      },
      allSelected: {
        tracking: false,
      },
      indeterminate: {
        tracking: true,
      },
      filterMonth: "",
      license_plat: null,
      lokasi: null,
      fav: null,
      vendor: null,
      tipePerangkat: null,
      filterHistory: null,
      filterActivity: null,
      totalRows: 1,
      historyRows: 0,
      activityRows: 0,
      currentPage: 1,
      historyPage: 1,
      activityPage: 1,
      perPage: 10,
      historyPerPage: 5,
      activityPerPage: 5,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      sortBy: "imei",
      sortDesc: false,
      form: {
        identifier: null,
        deviceCode: null,
        vendorCode: null,
        portKernel: 8099,
        companyId: 1,
        imei: null,
        phoneNo: null,
        status: 0,
      },
      formOld: {
        identifier: null,
        deviceCode: null,
        vendorCode: null,
        portKernel: 8099,
        companyId: 1,
        imei: null,
        phoneNo: null,
        status: 0,
      },
      show_model: null,
      show: [
        { key: "imei", label: "Imei" },
        { key: "identifier", label: "ID Pelacak" },
        { key: "vendorType", label: "Vendor" },
        { key: "deviceName", label: "Tipe Perangkat" },
        { key: "phoneNo", label: "No Telepon" },
        { key: "status", label: "Status" },
        { key: "createdOn", label: "Tanggal Dibuat" },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,

      vendorCode: [
        {
          key: 0,
          labelName: "McEasy",
        },
        {
          key: 1,
          labelName: "EasyGo",
        },
        {
          key: 2,
          labelName: "Foxlogger",
        },
        {
          key: 3,
          labelName: "SuperSpring",
        },
        {
          key: 100,
          labelName: "Other",
        },
      ],

      deviceCode: [
        {
          key: 1001,
          labelName: "Concox GT06N",
        },
        {
          key: 1002,
          labelName: "Concox X3",
        },
        {
          key: 1003,
          labelName: "Concox JC400 (Dashboard Camera)",
        },
      ],

      devices: {
        devices: [],
      },

      deviceHistories: {
        deviceHistories: [],
      },

      deviceTypes: {
        deviceType: [],
      },

      deviceTypeOptions: [],

      deviceLogs: {
        deviceLogs: [],
      },

      formStatus: "create",
      status: "",
      listDeleted: [],

      filteredItems: [],
    };
  },

  validations: {
    form: {
      identifier: { required },
      deviceCode: { required },
      // vendorCode: { required },
      imei: { required },
      phoneNo: { required },
      // status: { required },
    },
  },

  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.devices.devices.length;
    },

    title() {
      return this.$t('master.pelacak');
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key);

        return this.tracking.filter(function (item) {
          return item.key == "check" || result.includes(item.key);
        });
      } else {
        return this.tracking;
      }
    },

    totalTrue() {
      return this.selectedModel.tracking.filter((c) => c === true);
    },

    tracking() {
      return [
        {
          key: "imei",
          label: this.$t("master.list.tracker.imei"),
          sortable: true,
        },
        {
          key: "identifier",
          label: this.$t('master.list.tracker.trackerId'),
          sortable: true,
        },
        {
          key: "vendorType",
          label: this.$t("master.list.tracker.vendor"),
          sortable: true,
        },
        {
          key: "deviceName",
          label: this.$t('master.list.tracker.deviceType'),
          sortable: true,
        },
        {
          key: "phoneNo",
          label: this.$t("master.list.tracker.phoneNo"),
          sortable: true,
        },
        {
          key: "createdOn",
          label: this.$t("master.list.tracker.createdOn"),
          sortable: true,
        },
        {
          key: "status",
          label: this.$t("master.list.tracker.status"),
          sortable: true,
        },
      ];
    },

    listHistory() {
      return [
        {
          key: "licensePlate",
          label: "Kendaraan",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "imei",
          label: "IMEI",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "phoneNo",
          label: "Nomor Telepon",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "activeOn",
          label: "Waktu Awal",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "inactiveOn",
          label: "Waktu Akhir",
          thClass: "mc-table--50",
          sortable: true,
        },
      ];
    },

    activityHistory() {
      return [
        {
          key: "title",
          label: "Jenis Riwayat",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "messageOn",
          label: "Tanggal",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "description",
          label: "Keterangan",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "name",
          label: "Pengguna",
          thClass: "mc-table--50",
          sortable: true,
        },
        {
          key: "licensePlate",
          label: "Kendaraan",
          thClass: "mc-table--50",
          sortable: true,
        },
      ];
    },
  },
  methods: {
    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onFilteredHistory(filteredItems) {
      this.historyRows = filteredItems.length;
      this.historyPage = 1;
    },

    onFilteredActivity(filteredItems) {
      this.activityRows = filteredItems.length;
      this.activityPage = 1;
    },

    onRowClicked(item) {
      if (!this.getAccessRight()) return;
      this.form = {
        identifier: item.identifier,
        deviceCode: item.deviceCode,
        vendorType: item.vendorType,
        imei: item.imei,
        phoneNo: item.phoneNo,
        status: item.status == 1 || item.status == 0 ? 0 : 2,
        createdOn: item.createdOn,
        licensePlate: item.licensePlate,
        vehicleId: item.vehicleId,
      };

      this.formOld = {
        identifier: item.identifier,
        deviceCode: item.deviceCode,
        vendorType: item.vendorType,
        imei: item.imei,
        phoneNo: item.phoneNo,
        status: item.status == 1 || item.status == 0 ? 0 : 2,
      };

      this.formStatus = "update";
      this.$bvModal.show("modal-create");
    },

    addTracker(item) {
      if (!this.getAccessRight()) return;
      this.resetModal()
      this.form = {
        identifier: item.identifier,
        deviceCode: item.deviceCode,
        vendorType: item.vendorType,
        imei: item.imei,
        phoneNo: item.phoneNo,
        status: item.status == 1 || item.status == 0 ? 0 : 2,
      };

      this.formStatus = "create"
      this.$bvModal.show("modal-create-tracker");
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = [];
      this.selected[param] = [];
      if (checked) {
        for (let i = 0; i < this.devices.devices.length; i++) {
          this.selected[param].push(i);
          this.selectedModel[param].push(true);
        }
      } else {
        for (let i = 0; i < this.devices.devices.length; i++) {
          this.selectedModel[param].push(false);
        }
        this.selected[param] = [];
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data);
      } else {
        var myIndex = this.selected[param].indexOf(data);
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1);
        }
      }
    },

    toDelete() {
      let promises = [];
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_DELETE,
            variables: {
              imei: this.selected.tracking[i].imei,
            },
          })
        );
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.devices.refetch();
        this.clearDelete();
        this.$toast.success(`Data berhasil dihapus`);
      });
    },
    clearDelete() {
      this.allSelected.tracking = false;
      this.selectedModel.tracking = [];
      this.selected.tracking = [];
    },
    resetModal() {
      this.$v.form.imei.$reset()
      this.$v.form.identifier.$reset()
      this.$v.form.deviceCode.$reset()
      this.$v.form.phoneNo.$reset()
      this.form = {
        identifier: null,
        deviceCode: null,
        vendorCode: null,
        imei: null,
        phoneNo: null,
        status: 0,
      };

      this.formStatus = "create";
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return this.$toast.error(
          this.$t('master.form.tracker.formRequired')
        );
      }
      this.$v.$reset();
      let input = {
        identifier: this.form.identifier,
      };      
      if (this.formStatus === "create") {
        input = {
          imei: this.form.imei,
          identifier: this.form.identifier,
          phoneNo: this.form.phoneNo,
          deviceCode: this.form.deviceCode.value,
          vendorType: "McEasy",
          status: 1
        };
        this.$apollo
          .mutate({
            mutation: DEVICE_MUTATION_CREATE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response) {
              if (response.data.createDevice.isSuccessful) {
                this.$apollo.queries.devices.refetch();
                this.$toast.success(`Data berhasil ditambah`);
              } else {
                var errMsg = response.data.createDevice.message;
                if (errMsg == 'Error: "User not authorized"') {
                  return this.$toast.error(
                    "Anda tidak memiliki hak akses untuk menambah pelacak"
                  );
                } else {
                  return this.$toast.warning(
                    response.data.createDevice.message
                  );
                }
              }
            }
          });
      } else {
        input = {
          oldData: { identifier: this.formOld.identifier },
          newData: input,
          imei: this.form.imei,
        };
        this.$apollo
          .mutate({
            mutation: DEVICE_MUTATION_UPDATE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response) {
              if (response.data.updateDevice.isSuccessful) {
                this.$apollo.queries.devices.refetch();
                this.$toast.success(`Data berhasil diubah`);
              } else {
                var errMsg = response.data.updateDevice.message;
                if (errMsg == 'Error: "User not authorized"') {
                  return this.$toast.error(
                    "Anda tidak memiliki hak akses untuk mengubah pelacak"
                  );
                } else {
                  return this.$toast.warning(
                    response.data.updateDevice.message
                  );
                }
              }
            }
          });
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-create");
        this.$bvModal.hide("modal-create-tracker");
        this.resetModal();
      });
    },
    changeStatus(status) {
      this.status = status;
      if (this.selected.tracking.length > 0) {
        this.showModal = true;
      } else {
        this.$toast.error(
          `Minimal memilih satu atau lebih dari data di bawah.`
        );
      }
    },
    toChangeStatus() {
      let promises = [];
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_UPDATE,
            variables: {
              input: {
                imei: this.selected.tracking[i].imei,
                status: this.status == "Aktif" ? 0 : 2,
              },
            },
          })
        );
      }

      Promise.all(promises).then(() => {
        this.$toast.success(
          `Berhasil mengubah ${this.selected.tracking.length} status pelacak.`
        );
        this.showModal = false;
        this.$apollo.queries.devices.refetch();
        this.clearDelete();
      });
    },
    openModalHistoryTracker() {
      this.$apollo.queries.deviceHistories.refetch();
      this.$apollo.queries.deviceLogs.refetch();
    },
    redirectToVehiclePage() {
      this.$router.push({ name: 'Master Fleet Update', params: { id: this.form.vehicleId } });
    }
  },
};
</script>
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">{{ $t('master.textPelacak') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-dropdown
            right
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="mc-btn-download"
            v-if="phaseOneShow"
          >
            <template v-slot:button-content>
              Unduh <i class="mdi mdi-chevron-down ps-2"></i>
            </template>
            <b-dropdown-item
              ><i class="bx bx-book-content pe-1"></i> Unduh Tabel
              Excel</b-dropdown-item
            >
            <b-dropdown-item
              ><i class="bx bx-book-content pe-1"></i> Unduh Tabel
              PDF</b-dropdown-item
            >
          </b-dropdown>
          <b-button
            @click="$router.push({ name: 'Master Home Page' })"
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12 text-end">
          <div class="mc-table-filter">
            <a
              v-b-modal.modal-filter
              class="popup-form btn btn-outline-primary me-3 mc-btn-filter"
              href="javascript: void(0);"
              v-if="phaseOneShow"
            >
              <i class="mc-fa icon-outline_filter"></i> Filter
            </a>
            <b-dropdown variant="outline-primary" v-if="phaseOneShow">
              <template v-slot:button-content>
                Ubah Status
                <i class="mdi mdi-chevron-down"></i>
              </template>
              <b-dropdown-item @click="changeStatus('Aktif')"
                >Aktif</b-dropdown-item
              >
              <b-dropdown-item @click="changeStatus('Arsip')"
                >Arsip</b-dropdown-item
              >
            </b-dropdown>
            <a
                v-b-modal.modal-form-user
                class="popup-form btn btn-primary"
                href="javascript: void(0);"
                @click="addTracker"
              >
                <i class="mc-fa icon-outline_plus"></i>
                {{ $t('global.addField') }}
              </a>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <!-- Search -->
          <div
            class="col-sm-12 col-md-12 d-flex flex-row-reverse mc-table-view-wrapper"
          >
            <div class="mc-table-view">
              <p class="mc-label">{{ $t('global.shown') }}</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.object.allColumn')"
                track-by="label"
                label="label"
              >
                <template slot="singleLabel" slot-scope="{ option }">{{
                  option.name
                }}</template>
              </multiselect>
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
                <label
                  class="d-inline-flex align-items-center mc-table-view__search"
                >
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="form-control ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>

        <!-- Table Tracking -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            class="datatables"
            :items="devices.devices"
            :fields="visibleFields"
            responsive="lg"
            show-empty
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            @filtered="onFiltered"
            @row-clicked="onRowClicked"
            :busy="$apollo.queries.devices.loading"
            @hidden="resetModal"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>

            <template #cell(imei)="data">
              <strong class="text-primary">
                {{ data.item.imei }}
              </strong>
            </template>

            <template #cell(status)="data">
              <span
                class="mc-status mc-status--green"
                v-if="data.item.status === 0 || data.item.status === 1"
              >
                Aktif
              </span>
              <span
                class="mc-status mc-status--grey"
                v-else-if="data.item.status === 2"
              >
                Arsip
              </span>
            </template>

            <template #cell(createdOn)="data">
              <p class="my-0">
                {{ data.item.createdOn ? momentDateShortMonth(data.item.createdOn) : '-' }}
              </p>
              <p class="text-muted my-0">
                {{ data.item.createdOn ? momentTime(data.item.createdOn) : '' }}
              </p>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Menampilkan
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                >
                </b-form-select>
                entri.
                <p>
                  Menampilkan&nbsp;<strong>{{
                    filteredItems.length > 0
                      ? (currentPage - 1) * perPage + 1
                      : 0
                  }}</strong
                  >&nbsp;sampai&nbsp;<strong>{{
                    Math.min(filteredItems.length, currentPage * perPage)
                  }}</strong
                  >&nbsp;dari&nbsp;<strong>{{ filteredItems.length }}</strong
                  >&nbsp;entri.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create -->
    <b-modal
      id="modal-create"
      ref="modal-create"
      size="lg"
      :title="$t('master.form.tracker.updateTracker')"
      @hidden="resetModal"
      centered
      footer-class="d-flex justify-content-between"
    >
      <form ref="form" class="mc-form" @submit.prevent="handleSubmit">
        <b-row>
          <!-- IMEI -->
          <b-col md="3">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.imei') }}</span>
              <strong>{{ form.imei }}</strong>
            </div>
          </b-col>

          <!-- Phone No -->
          <b-col md="2">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.phoneNo') }}</span>
              <strong>{{ form.phoneNo ?? '-' }}</strong>
            </div>
          </b-col>

          <!-- Vendor -->
          <b-col md="2">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.vendor') }}</span>
              <strong>{{ form.vendorType }}</strong>
            </div>
          </b-col>

          <!-- Tipe Perangkat -->
          <b-col md="2">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.deviceType') }}</span>
              <strong>{{ form.deviceCode }}</strong>
            </div>
          </b-col>

          <!-- Tanggal Dibuat -->
          <b-col md="3">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.createdOn') }}</span>
              <strong class="my-0">
                {{ form.createdOn ? momentDMY_HI(form.createdOn) : '-' }}
              </strong>
            </div>
          </b-col>

          <!-- Tracking ID -->
          <b-col md="12">
            <div class="mb-3 mc-input-info">
              <span
                class="mc-input-info__btn"
                v-b-tooltip.hover.leftbottom="$t('master.form.tracker.trackerIdInfo')"
              >
                <i class="bx bx-info-circle"></i>
              </span>
              <b-form-group
                id="tracker_id_label"
                :label="$t('master.form.tracker.trackerId')"
                label-for="tracker_id"
                label-class="required"
              >
                <b-form-input
                  id="tracker_id"
                  :placeholder="`${$t('global.form.enter')} ${$t(
                    'master.list.tracker.trackerId'
                  )}`"
                  v-model="form.identifier"
                  trim
                  :class="{'is-invalid':$v.form.identifier.$error,}"
                ></b-form-input>
                <div v-if="$v.form.identifier.$error" class="invalid-feedback">
                  <span v-if="!$v.form.identifier.required">
                    {{ $t('master.form.tracker.trackerId') }}
                    {{ $t("global.validation.required") }}
                  </span>
                </div>
              </b-form-group>
            </div>
          </b-col>

          <!-- Status -->
          <b-col md="12">
            <b-form-group
              id="status_label"
              :label="$t('master.form.tracker.status')"
              label-for="status"
            >
              <div class="mb-3">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="status"
                    id="assignedStatus"
                    :value="0"
                    v-model="form.status"
                    :disabled="true"
                  />
                  <label class="form-check-label" for="assignedStatus"
                    >Aktif</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="status"
                    id="disableStatus"
                    :value="2"
                    v-model="form.status"
                    :disabled="true"
                  />
                  <label class="form-check-label" for="disableStatus"
                    >Arsip</label
                  >
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.licensePlate">
          <b-col md="12">
            <div class="mb-3 mc-input-info">
              <b-button
                variant="link"
                class="mc-input-info__btn p-0"
                v-b-tooltip.hover.leftbottom="$t('master.form.tracker.vehicleInfo')"
                @click="redirectToVehiclePage"
              >
                <i class="bx bx-link"></i>
              </b-button>
              <b-form-group
                id="vehicel_label"
                :label="$t('master.form.tracker.vehicle')"
                label-for="vehicle_id"
              >
                <b-form-input
                  id="vehicle_id"
                  v-model="form.licensePlate"
                  trim
                  disabled
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </form>
      <template #modal-footer="{ cancel }">
        <div>
          <b-button
            variant="outline-primary"
            class="me-3"
            v-b-modal.modal-history-tracker
            @click="openModalHistoryTracker"
          >
            Riwayat
          </b-button>
        </div>
        <div>
          <b-button variant="outline-primary" @click="cancel()" class="me-3">
            {{ $t('global.cancel') }}
          </b-button>
          <b-button variant="primary" @click="handleOk"> {{ $t('global.save') }} </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Riwayat -->
    <b-modal
      id="modal-history-tracker"
      centered
      title="Riwayat Pelacak - SB 1234 LL"
      title-class="font-18"
      hide-footer
      size="lg"
    >
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted">
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-sm-inline-block">Perubahan Data</span>
            </template>

            <div>
              <div class="clearfix">
                <!-- Search -->
                <div class="float-end">
                  <div class="mc-table-view">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-end"
                    >
                      <label
                        class="d-inline-flex align-items-center mc-table-view__search"
                      >
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterHistory"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <!-- End search -->
              </div>

              <!-- Table -->
              <div class="table-responsive my-3 border border-1">
                <b-table
                  small
                  show-empty
                  :fields="listHistory"
                  :items="deviceHistories.deviceHistories"
                  class="datatables"
                  responsive="md"
                  :empty-text="$t('global.emptyTable')"
                  :empty-filtered-text="$t('global.emptyFilteredTable')"
                  :per-page="historyPerPage"
                  :current-page="historyPage"
                  :filter="filterHistory"
                  @filtered="onFilteredHistory"
                >
                  <template #cell(activeOn)="row">
                    <div>
                      <p class="font-weight-bold">
                        {{ row.item.activeOnDateFormat }}
                      </p>
                      <p class="text-muted">{{ row.item.activeOnTimeFormat }}</p>
                    </div>
                  </template>
                  <template #cell(inactiveOn)="row">
                    <div>
                      <p class="font-weight-bold">
                        {{ row.item.inactiveOnDateFormat }}
                      </p>
                      <p class="text-muted">{{ row.item.inactiveOnTimeFormat }}</p>
                    </div>
                  </template>
                </b-table>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <p>
                    Menampilkan&nbsp;<strong>{{
                      historyRows > 0
                        ? (historyPage - 1) * historyPerPage + 1
                        : 0
                    }}</strong
                    >&nbsp;sampai&nbsp;<strong>{{
                      Math.min(historyRows, historyPage * 5)
                    }}</strong
                    >&nbsp;dari&nbsp;<strong>{{ historyRows }}</strong
                    >&nbsp;entri.
                  </p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end mb-0"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="historyPage"
                        :total-rows="historyRows"
                        :per-page="historyPerPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-sm-inline-block">Aktivitas Pelacak</span>
            </template>

            <div>
              <div class="clearfix">
                <!-- Search -->
                <div class="float-end">
                  <div class="mc-table-view">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-end"
                    >
                      <label
                        class="d-inline-flex align-items-center mc-table-view__search"
                      >
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterActivity"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <!-- End search -->
              </div>

              <!-- Table -->
              <div class="table-responsive my-3 border border-1">
                <b-table
                  small
                  show-empty
                  :fields="activityHistory"
                  :items="deviceLogs.deviceLogs"
                  class="datatable"
                  responsive="md"
                  :empty-text="$t('global.emptyTable')"
                  :empty-filtered-text="$t('global.emptyFilteredTable')"
                  :per-page="activityPerPage"
                  :current-page="activityPage"
                  :filter="filterActivity"
                  @filtered="onFilteredActivity"
                >
                  <template #cell(messageOn)="row">
                    <div>
                      <p class="font-weight-bold">
                        {{ row.item.messageOnDateFormat }}
                      </p>
                      <p class="text-muted">{{ row.item.messageOnTimeFormat }}</p>
                    </div>
                  </template>
                </b-table>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <p>
                    Menampilkan&nbsp;<strong>{{
                      activityRows > 0
                        ? (activityPage - 1) * activityPerPage + 1
                        : 0
                    }}</strong
                    >&nbsp;sampai&nbsp;<strong>{{
                      Math.min(activityRows, activityPage * activityPerPage)
                    }}</strong
                    >&nbsp;dari&nbsp;<strong>{{ activityRows }}</strong
                    >&nbsp;entri.
                  </p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end mb-0"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="activityPage"
                        :total-rows="activityRows"
                        :per-page="activityPerPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-modal>

    <!-- Status -->
    <b-modal
      v-model="showModal"
      title="Ubah Status"
      body-class="p-3"
      hide-footer
      size="md"
      centered
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <p>
            Apakah anda yakin mengubah status data berikut menjadi
            <b>{{ status }}</b> ?
          </p>

          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr></tr>
              </thead>
              <tbody>
                <tr v-for="device in selected.tracking" :key="device.imei">
                  <td>{{ device.identifier }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button variant="outline-primary" @click="showModal = false"
            >Tidak</b-button
          >
          <b-button
            type="submit"
            variant="primary"
            class="ms-2"
            @click="toChangeStatus"
            >Ya</b-button
          >
        </div>
      </form>
    </b-modal>

    <!-- Filter -->
    <b-modal
      class="mc-modal"
      id="modal-filter"
      title="Filter"
      size="lg"
      centered
      scrollable
    >
      <div class="card-body mc-modal__filter">
        <form>
          <div class="mc-modal__filter-item">
            <b-form-group label="Status" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selected"
                :options="['Aktif']"
                :aria-describedby="ariaDescribedby"
                name="flavour-1"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
          <div class="mc-modal__filter-item">
            <label class="mt-3">Vendor</label>
            <multiselect
              v-model="vendor"
              :options="[
                'McEasy',
                'EasyGo',
                'Foxlogger',
                'Other',
                'Tidak Berkategori',
              ]"
              :multiple="true"
              placeholder="Vendor"
            ></multiselect>
          </div>
          <div class="mc-modal__filter-item">
            <label>Tipe Perangkat</label>
            <multiselect
              v-model="tipePerangkat"
              :options="['X100', 'TRV102', 'Concox X3', 'FMB103']"
              :multiple="true"
              placeholder="Tipe Perangkat"
            ></multiselect>
          </div>
          <div class="mc-modal__filter-item">
            <div class="form-check form-switch mb-3">
              <input
                type="checkbox"
                id="switchArsip"
                class="form-check-input"
              /><label for="switchArsip" class="form-check-label"
                >Tampilkan Status Arsip</label
              >
            </div>
          </div>
        </form>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
            <b-row>
              <b-col md="6">
                <b-form-group
                  v-if="!isAddFavorit"
                  id="favorit-label-modal"
                  label="Favorit"
                  label-for="favorit-modal"
                >
                  <multiselect
                    v-model="fav"
                    :options="[
                      'Semua Status',
                      'Status Aktif',
                      'Status Nonaktif',
                    ]"
                    :show-labels="false"
                  ></multiselect>
                </b-form-group>
                <b-form-group
                  v-if="isAddFavorit"
                  id="favorit-add-label-modal"
                  label="Favorit"
                  label-for="favorit-modal-add"
                >
                  <b-form-input
                    id="favorit-modal-add"
                    v-model="addFavorit"
                    placeholder="Nama Favorit"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-button
                  v-if="!isAddFavorit"
                  variant="outline-primary"
                  @click="isAddFavorit = !isAddFavorit"
                >
                  <i class="mdi mdi-file-plus-outline"></i> Buat Favorit Baru
                </b-button>
                <b-button v-if="isAddFavorit" variant="outline-primary">
                  <i class="fas fa-save"></i> Simpan Sebagai Favorit
                </b-button>
                <i
                  v-if="isAddFavorit"
                  class="fas fa-trash text-danger text-lg mt-4 ms-3"
                  @click="isAddFavorit = !isAddFavorit"
                ></i>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-3">
              Batal
            </b-button>
            <b-button variant="primary"> Terapkan </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Modal for add tracker -->
    <b-modal
        class="mc-modal"
        id="modal-create-tracker"
        :title="$t('master.form.tracker.createTracker')"
        size="lg"
        centered
        scrollable
        @hidden="resetModal"
        @ok="handleOk"
        footer-class="d-flex justify-content-between"
      >
        <div class="card-body mc-modal__filter p-2">
          <form @submit.stop.prevent="handleSubmit">
            <div class="mb-2">
              <label class="required">{{ $t('master.form.tracker.imei') }}</label>
              <b-form-input placeholder="Input IMEI" v-model="form.imei" :class="{
                'is-invalid': $v.form.imei.$error,
              }"></b-form-input>
              <div v-if="$v.form.imei.$error" class="invalid-feedback d-block">
                <span v-if="!$v.form.imei.required"> 
                  {{ $t('master.form.tracker.imei') }}
                  {{ $t("global.validation.required") }} </span>
              </div>
            </div>
            <div class="mb-2 mc-input-info">
              <label class="required">{{ $t('master.form.tracker.trackerId') }}</label>
              <span class="mc-input-info__btn" v-b-tooltip.click.leftbottom="$t('master.form.tracker.trackerIdInfo')"><i class="bx bx-info-circle"></i></span>
              <b-form-input placeholder="Input Tracker ID" v-model="form.identifier" :class="{
                'is-invalid': $v.form.identifier.$error,
              }"></b-form-input>
              <div v-if="$v.form.identifier.$error" class="invalid-feedback d-block">
                <span v-if="!$v.form.identifier.required"> 
                  {{ $t('master.form.tracker.trackerId') }}
                  {{ $t("global.validation.required") }} </span>
              </div>
            </div>
            <div class="mb-2">
              <label class="required">{{ $t('master.form.tracker.vendor') }}</label>
              <b-form-input placeholder="McEasy" v-model="form.vendorCode" disabled></b-form-input>
            </div>
            <div class="mc-modal__filter-item">
              <label class="required">{{ $t('master.form.tracker.deviceType') }}</label>
              <multiselect
                v-model="form.deviceCode"
                label="label"
                :options="deviceTypeOptions"
                placeholder="Select Device Type"
                :class="{
                  'is-invalid': $v.form.deviceCode.$error,
                }"
              >
              </multiselect>
              <div v-if="$v.form.deviceCode.$error" class="invalid-feedback d-block">
                <span v-if="!$v.form.deviceCode.required"> 
                  {{ $t('master.form.tracker.deviceType') }}
                  {{ $t("global.validation.required") }} </span>
              </div>
            </div>
            <div class="mb-2">
                <label class="required">{{ $t('master.form.tracker.phoneNo') }}</label>
                <b-form-input placeholder="Input Phone No" v-model="form.phoneNo" :class="{
                  'is-invalid': $v.form.phoneNo.$error,
                }"></b-form-input>
                <div v-if="$v.form.phoneNo.$error" class="invalid-feedback d-block">
                  <span v-if="!$v.form.phoneNo.required">
                    {{ $t('master.form.tracker.phoneNo') }}
                    {{ $t("global.validation.required") }} </span>
                </div>
            </div>
          </form>
        </div>
        <template #modal-footer="{ cancel }">
          <div></div>
          <div>
            <b-button variant="outline-primary" @click="cancel()" class="me-3"> {{ $t('global.cancel') }} </b-button>
            <b-button variant="primary" @click="handleOk"> {{ $t('global.save') }} </b-button>
          </div>
        </template>
      </b-modal>
  </Layout>
</template>
